"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
require("./themes/DefaultTheme.css");
var theme = {
  "sidebar-heading": "DefaultTheme__sidebar-heading___12Zgy",
  "icon": "DefaultTheme__icon___2S5qi",
  "sidebarHeading": "DefaultTheme__sidebar-heading___12Zgy"
};
/** We display in the Sidebar either titles or links.
 *  For now, we use href to differentiate between them.
 */
/**
 * The primary navigation element within an Anypoint product.
 */
var SidebarHeading = exports["default"] = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(SidebarHeading, _React$PureComponent);
  function SidebarHeading() {
    (0, _classCallCheck2["default"])(this, SidebarHeading);
    return _callSuper(this, SidebarHeading, arguments);
  }
  (0, _createClass2["default"])(SidebarHeading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        label = _this$props.label,
        icon = _this$props.icon;
      return /*#__PURE__*/_react["default"].createElement("h3", {
        style: {
          fontSize: '14px',
          marginTop: '0'
        } // override anypoint-styles
        ,
        className: theme.sidebarHeading
      }, icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: theme.icon,
        name: icon,
        size: "xs"
      }), label);
    }
  }]);
  return SidebarHeading;
}(_react["default"].PureComponent);
//# sourceMappingURL=index.js.map